import { useState, useEffect } from 'react';
import VariablesModule from 'ui-connect/styles/variables.module.css';
const { startSM } = VariablesModule;

const useMobileView = (useMainBody = false) => {
    const [isMobileView, setIsMobileView] = useState(getIsMobileView(useMainBody));

    useEffect(() => {
        window.addEventListener('resize', updateIsMobileView);
        updateIsMobileView();

        return () => {
            window.removeEventListener('resize', updateIsMobileView);
        };
    });

    const updateIsMobileView = () => {
        const isMobileView = getIsMobileView(useMainBody);
        setIsMobileView(isMobileView);
    };

    return isMobileView;
};

export const getIsMobileView = (useMainBody) => {
    // use 'font-size' of head to get default font size (not from body because it's overwritten in global.css)
    const defaultFontSize = parseFloat(getComputedStyle(document.head).fontSize);
    // Use main-body to do calculation since window.innerWidth includes the width of the main nav.
    const content = document.getElementsByClassName('main-body');

    return (useMainBody ? content[0].offsetWidth : window.innerWidth) < parseInt(startSM) * defaultFontSize;
};

export default useMobileView;
